// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"a7139790","184":"a75fc522","313":"c6829450","453":"a63875d8","472":"9cc90410","489":"1524aacd","507":"884cfa1e","522":"db04be47","737":"48e131fb","798":"d43e6ada","924":"c3ad6864","933":"6c5abaef","961":"b084a360"}[chunkId] + ".chunk.js";
};